import React from 'react';

function SearchIcon({ fill = '#333333', size = 20 }: { fill?: string; size?: number | string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2854 17.1474L11.0514 11.9134C10.6347 12.2575 10.1555 12.5267 9.61388 12.7211C9.07221 12.9156 8.51185 13.0128 7.9328 13.0128C6.50849 13.0128 5.30306 12.5196 4.3165 11.5333C3.32995 10.547 2.83667 9.34191 2.83667 7.91798C2.83667 6.49403 3.32982 5.28847 4.31613 4.30129C5.30243 3.31412 6.50756 2.82054 7.9315 2.82054C9.35543 2.82054 10.561 3.31382 11.5482 4.30038C12.5354 5.28693 13.0289 6.49236 13.0289 7.91667C13.0289 8.51175 12.929 9.08013 12.7293 9.62179C12.5295 10.1635 12.2629 10.6346 11.9296 11.0352L17.1635 16.2692L16.2854 17.1474ZM7.9328 11.7628C9.00652 11.7628 9.91598 11.3902 10.6612 10.645C11.4064 9.89985 11.779 8.99039 11.779 7.91667C11.779 6.84294 11.4064 5.93349 10.6612 5.18829C9.91598 4.4431 9.00652 4.0705 7.9328 4.0705C6.85907 4.0705 5.94961 4.4431 5.20442 5.18829C4.45924 5.93349 4.08665 6.84294 4.08665 7.91667C4.08665 8.99039 4.45924 9.89985 5.20442 10.645C5.94961 11.3902 6.85907 11.7628 7.9328 11.7628Z"
        fill={fill}
      />
    </svg>
  );
}

export default SearchIcon;
